import type { GetNewsArticlePreviewsQueryResult } from '@dreamstack/investors-graphql'
import map from 'lodash/map'
import type { FunctionComponent } from 'react'
import { NewsHubPreview } from './NewsHubPreview'
import { NewsHubStackGrid } from './NewsHubStackGrid'

export const ArticlePreviewGrid: FunctionComponent<
  React.PropsWithChildren<{
    articles: NonNullable<
      NonNullable<GetNewsArticlePreviewsQueryResult['data']>['newsArticles']
    >['items']
  }>
> = ({ articles }) => {
  return (
    <>
      <NewsHubStackGrid>
        {map(articles, (article, i) => {
          return <NewsHubPreview key={i} article={article} />
        })}
      </NewsHubStackGrid>
    </>
  )
}
